import * as actions from './actions'
import {Map,  List, fromJS} from 'immutable';


function reducer(
        state=Map({
            isFetching: false,
            items: List(),
            unread: 0,
        }),action) {
    switch (action.type) {
        // ========= READ ===========
        case actions.NOTIFICATION_READ_SUCCESS:
            return state.set('items', fromJS(action.notification))
                        .set('isFetching', action.isFetching)
        case actions.NOTIFICATION_READ_FAILURE:
        case actions.NOTIFICATION_READ_REQUEST:
            return state.set('isFetching', action.isFetching)
        case actions.SET_NOTIFICATION_READ:
            return state.setIn(['items', 0, 'is_read'], true);
        case actions.ADD_NOTIFICATION:
            return state.updateIn(['items'], items => items.unshift(fromJS(action.notification)))
        default:
            return state

      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/Notification/reducer.js